/*
 * ******************************************************************************
 * Copyright Innov'ATM all rights reserved. This software is the property of
 * Innov'ATM and may not be used in any manner except under a license agreement
 * signed with Innov'ATM.
 * *******************************************************************************
 */
import { memo } from 'react';

import { ONE_HOUR } from '../../../../config/constants';
import { FormattedTime } from '../../../time/FormattedTime';
import { useRmsGanttValue } from '../RmsContext';
import { getGanttNbTimelineHours } from './gantt.utils';
import {
    GanttTimelineBox,
    GanttTimelineStepBox,
    GanttTimelineStepLabelBox,
    GanttTimelineStepLineBox,
} from './GanttTimeline.style';

export const GanttTimeline = memo(() => {
    const { from, to } = useRmsGanttValue('dayBounds');
    const ganttNbTimelineHours = getGanttNbTimelineHours(from, to);
    const hours = Array(ganttNbTimelineHours * 2 + 1)
        .fill(null)
        .map((_, i) => from + (i * ONE_HOUR) / 2);

    return (
        <GanttTimelineBox>
            {hours.map((hour, i) => {
                const isLastStep = i === hours.length - 1;
                return (
                    <GanttTimelineStepBox key={hour} sx={isLastStep ? { width: 0 } : undefined}>
                        <GanttTimelineStepLabelBox>
                            <FormattedTime>{hour}</FormattedTime>
                        </GanttTimelineStepLabelBox>
                        {!isLastStep && <GanttTimelineStepLineBox />}
                    </GanttTimelineStepBox>
                );
            })}
        </GanttTimelineBox>
    );
});
